module.exports = __webpack_public_path__ + "img/g1.a02cfb8c.jpg";